import React from 'react';
import Body from 'gatsby-core-theme/src/components/pages/body';

export default (props) => (
  <Body 
    {...props} 
    showFloatingArea
  />
)